import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { NEVER, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient, private router: Router, private oidcSecurityService: OidcSecurityService) { }

  api = 'https://app.ostadvisit.com';
  token: any;

  apiCall(method, route, body?, params?) {
    this.oidcSecurityService.getAccessToken().subscribe((token) => {
      this.token = token;
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.token,
      // deviceHash: '82d8a70c2ce951ba45aef4b5dd0dedad'
    });

    if ( method === 'post' ) {
      return this.http.post(this.api + route, body, {headers, observe: 'response'}).pipe(
        catchError(error => {
          if(error.status == 401) {
            this.router.navigate(['']);
          } else if (error.status == 403) {
            this.router.navigate(['/forbidden']);
            return NEVER;
          } else {
            console.log('ERROR:',error);
          }
          return of([]);
        })
      )
    } else if ( method === 'get') {
      return this.http.get(this.api + route, {headers, observe:'response', params:params}).pipe(
        catchError(error => {
          if(error.status == 401){
            this.router.navigate(['']);
            return NEVER;
          } else if (error.status == 403) {
            this.router.navigate(['/forbidden']);
            return NEVER;
          } else {
            console.log('ERROR:',error);
          }
          return of([]);
        })
      )
    } else if ( method === 'delete') {
      return this.http.delete(this.api + route, {headers, observe: 'response'}).pipe(
        catchError(error => {
          if (error.status == 401){
            this.router.navigate(['']);
            return NEVER;
          } else {
            console.log('ERROR:',error);
          }
          return of([]);
        })
      )
    } else if ( method === 'put') {
      return this.http.put(this.api + route, body, { headers ,observe:'response'}).pipe(
        catchError (error => {
          // console.log(error);
          
          if(error.status == 401){
            this.router.navigate(['']);
            return NEVER;
          } else if (error.status == 403) {
            this.router.navigate(['/forbidden']);
            return NEVER;
          } else {
            console.log('ERROR:',error);
          }
          return of([]);          
        })
      )
    }

  }

  callFormDataApi(route, formData) {
    const headers= new HttpHeaders({
      'encrypt': 'multipart/form-data',
      Authorization: 'Bearer ' + this.token
    });
    return this.http.post(this.api + route , formData ,  
      {headers, observe: 'response'}).pipe(
      catchError(error => {
        console.log(error);
        
        if (error.status == 403) {
          this.router.navigate(['']);
          
        }
        return of([]);
      })
    )
  }   

  // isUserDoctor(): Observable<boolean> {
  //   // return this.apiCall('get', '/api/SiteDoctors/GetDoctorRole', {}).pipe(
  //   //   map((res: any) => {
  //   //     console.log('/*/*/*/*/*/*/*/',res);
  //   //     return res.body?.model?.isDoctor ?? false; // Ensure safe access & return false if undefined
  //   //   })
  //   // );

  //   return this.apiCall('get', '/api/SiteDoctors/GetDoctorRole', {}).pipe(
  //     tap((res) => console.log('API Executed:', res)), // Debugging
  //     map((res: any) => res?.body?.model?.isDoctor ?? false)
  //   );
  // }

}
